module.exports = "./img/7d44f1a59093b5996396dce5b9a38fd2.jpg";